import { FormattedMessage } from 'react-intl';

const AppSalesPitch = () => {
  return <FormattedMessage defaultMessage="Navigate on the trail and track all your adventures with the award-winning app." />;
};

export default AppSalesPitch;
